import script from "./contentsMainPage.vue?vue&type=script&setup=true&lang=js"
export * from "./contentsMainPage.vue?vue&type=script&setup=true&lang=js"

import "./contentsMainPage.vue?vue&type=style&index=0&id=dc76920e&lang=css"

const __exports__ = script;

export default __exports__